/**
/**
 * getQuestion.js
 * Written by: Alex Kasemir
 */
import quizActions from 'store/quiz/actions';
import request from '../../../request/actions';
import nextQuestionRaw from '../../selectors/nextQuestion';
import { selectNextQuestion } from '../../actions/selectNextQuestion';
import { selectQuiz } from '../../../quiz/actions/selectQuiz';
import alertActions from '../../../alert/actions';

export const GET_QUESTION_START = `GET_QUESTION_START`;
export const GET_QUESTION_SUCCESS = `GET_QUESTION_SUCCESS`;
export const GET_QUESTION_FAILURE = `GET_QUESTION_FAILURE`;

export const getQuestionStart = (id) => ({
  type: GET_QUESTION_START,
  id,
});

export const getQuestionSuccess = (id, question) => ({
  type: GET_QUESTION_SUCCESS,
  id,
  question,
});

export const getQuestionFailure = (error) => ({
  type: GET_QUESTION_FAILURE,
  error,
});

/**
 * Description of the getQuestion action
 */

export const getQuestion = (id) => {
  return (dispatch, getState) => {
    dispatch(getQuestionStart(id));
    const nextQuestionId = nextQuestionRaw(getState());
    if (id === nextQuestionId) {
      dispatch(alertActions.createAlert({
        message: `You cannot skip the last question in a quiz!`,
        type: `danger`,
      }));
    }

    return new Promise((resolve, reject) => {
      dispatch(request(`/questions/${id}/`, `GET`))
        .then(async (response) => {
          if (!getState().quiz.selected) {
            await dispatch(quizActions.getQuiz(response.data.quiz, true));
            await dispatch(quizActions.getQuizResults(response.data.quiz));
          }
          dispatch(selectQuiz(response.data.quiz));
          dispatch(getQuestionSuccess(response.data.id, response.data));
          dispatch(selectNextQuestion(response.data.id));
          resolve(response.data);
        })
        .catch((error) => {
          dispatch(getQuestionFailure(error));
          reject();
        });
    });
  };
};
